<template>
  <div class="preview">
    <div class="full-screen-image">
      <img :src="srcImageUploaded" alt="Image Preview">
      <div class="focused-rectangle"></div>
    </div>
    <div class="preview__cardPreview">
      <h2>A foto ficou boa?</h2>
      <span>A foto deve estar nítida</span>
      <div class="cardPreview__buttons">
        <button class="button button--text-button" @click.prevent="chooseAnotherFile">Voltar</button>
        <button class="button button--primary button--half-width" @click.prevent="confirmUploadFile">Sim</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      srcImageUploaded: {
        type: String,
        required: true
      },
      chooseAnotherFile: {
          type: Function,
          required: false
      },
      confirmUploadFile: {
          type: Function,
          required: false
      }
    },
    methods: {
      primaryActionComponent(){
        this.chooseAnotherFile()
        this.confirmUploadFile()
      }
    }
  }
</script>
<style lang="scss">
  @import "@vuxx/hounds/scss/abstracts/mixins";
  @import "@vuxx/hounds/scss/abstracts/variables";

  .preview__cardPreview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 1.5rem 1.5rem 2.125rem 1.5rem;
    box-shadow  : 0px -5px 5px 0px #0000001A;
    background-color: #fff;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding-bottom: 16px;
    padding-top: 24px;
    height: 20%;
  }
  .preview__cardPreview h2 {
    font-size: 16px;
    font-weight: 500;
    color: #22232C;
  }
  .preview__cardPreview span {
    font-size: 14px;
    font-weight: 500;
    color: #435254;
  }
  .cardPreview__buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
  }
  .cardPreview__buttons button {
    width: 148px;
  }
  full-screen-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }
  .full-screen-image img {
    max-width: 100%;
    max-height: 81vh;
    object-fit: contain;
    width: 100%;
    height: 81vh;
  }
  .focused-rectangle {
    position: absolute;
    top: 10%;
    left: 16px;
    right: 16px;
    bottom: 0;
    background-size: cover;
    box-shadow: 0 0 0 2000px rgba(0, 0, 0, 0.5);
    filter: none;
  }
</style>
